import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'
import ButtonStartIcon from '../../../../button/ButtonStartIcon'
import List from './List/List'
import LcElementDialog from './Dialog/Dialog'
import useLcElements from '../../../../../hooks/curriculum/useLcElements'

const LcElements = () => {
  const [type, setType] = useState(null)
  const [form, setForm] = useState(null)
  const permission = useSelector((state) => state?.session?.permissions ? state?.session?.permissions['curriculum-lc-elements'] || {} : {})

  const data = useSelector((state) => state?.curriculum?.lcElements || {})
  const { isLoadingList } = useLcElements()
  const onModal = (type = null, form = {}) => {
    setType(type)
    setForm(form)
  }

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between sticky top-0 z-10 h-8'>
        <Typography variant='subtitle1' className='uppercase'>{data.name}</Typography>
        { permission['created'] && 
          <ButtonStartIcon
            onClick={() => onModal('create', {})}
            color='secondary'
            variant='contained'
            startIcon={["fas","plus"]}
          >
            Create
          </ButtonStartIcon>
        }
      </Box>
      <Box className='px-2 py-2'>
        <List
          isLoading={isLoadingList}
          listTemp={data?.children?.sort((a, b) => a.position - b.position) || []}
          permissions={permission}
          name={data.name}
          onAction={(type, form) => onModal(type, form)}
        />
      </Box>
      { type &&
        <LcElementDialog 
          type={type}
          show={!!type} 
          onClose={() => onModal(null, {})} 
          data={form || {}}
        />
      }
    </>
  )
}

export default LcElements